import React, { useState } from "react";
import { Form, Modal, Result, Spin } from "antd";
import CreditiForm from "./CreditiForm";

const ModalResult = ({ creditiModalResult }) => {
  if (creditiModalResult === "OK") {
    return (
      <Result
        status="success"
        title="Ordine creato con successo"
        subTitle="In pochi secondi l'ordine verrà processato"
      />
    );
  } else {
    return (
      <Result
        status="error"
        title="Qualcosa è andato storto"
        subTitle="L'ordine non è stato creato"
      />
    );
  }
};

const CreditiModal = (props) => {
  const [form] = Form.useForm();
  const [loading, setIsLoading] = useState(false);

  if (props.creditiModalResult) {
    return (
      <Modal
        visible={props.visible}
        title="Crea un ordine di crediti"
        cancelText=""
        onCancel={() => {
          setIsLoading(false);
          props.onResultAcked();
        }}
        onOk={() => {
          setIsLoading(false);
          props.onResultAcked();
        }}
      >
        <ModalResult creditiModalResult={props.creditiModalResult} />
      </Modal>
    );
  }

  return (
    <Modal
      visible={props.visible}
      title="Crea un ordine di crediti"
      okText="Crea Ordine"
      cancelText="Annulla"
      onCancel={() => {
        setIsLoading(false);
        props.onCancel();
      }}
      onOk={() => {
        setIsLoading(true);
        form
          .validateFields()
          .then((values) => {
            form.resetFields();
            props.onCreate(values);
          })
          .catch((info) => {
            console.error("Validate Failed:", info);
          });
      }}
    >
      {!loading && <CreditiForm form={form} />}
      {loading && <Spin size="large" />}
    </Modal>
  );
};

export default CreditiModal; 